// extracted by mini-css-extract-plugin
export default {"container":"styles_container__aP6If","content":"styles_content__-F+xJ","information":"styles_information__bdmgb"};